import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_base_notificator = _resolveComponent("base-notificator")

  return (_ctx.isNotificatorVisible)
    ? (_openBlock(), _createBlock(_component_base_notificator, {
        key: 0,
        type: "warning",
        "can-close": false,
        class: "_my-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_localize, { resource: _ctx.paragraphText }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                "format-key": "0",
                class: "_tdu",
                href: _ctx.checkoutReturnActionUrl
              }, _toDisplayString(_ctx.linkText), 9 /* TEXT, PROPS */, _hoisted_1)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"])
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}